import { cx } from '@linaria/core';
import 'react';
import { avoidBreakInside } from '@provider/print';
import { CrossIcon, RoundedCheckmarkIcon } from '@ui/kit/icons';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { toggle, toggleIcon, content, icon, box } from './_media-box.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function MediaBox(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  const icon$1 = (() => {
    switch (props.state) {
      case "correct":
        return /*#__PURE__*/jsx(RoundedCheckmarkIcon, {
          height: 18,
          strokeWidth: 1.5
        });
      case "incorrect":
        return /*#__PURE__*/jsx(CrossIcon, {
          strokeWidth: 1,
          height: 16
        });
    }
  })();
  const handleTogglerClick = evt => {
    evt.stopPropagation();
    props.onChange();
  };
  const toggler = props.state === "input" ? /*#__PURE__*/jsx("button", {
    className: toggle,
    "aria-label": props.checked ? `Fravælg element` : "Vælg element",
    "data-orientation": props.orientation,
    "data-checked": props.checked,
    "data-state": props.state,
    "data-theme": props.theme,
    onClick: handleTogglerClick,
    children: /*#__PURE__*/jsx("span", {
      className: toggleIcon
    })
  }) : /*#__PURE__*/jsx("span", {
    className: toggle,
    "data-orientation": props.orientation,
    "data-checked": props.checked,
    "data-state": props.state,
    "data-theme": props.theme,
    children: /*#__PURE__*/jsx("span", {
      className: toggleIcon
    })
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    jsxs("div", {
      className: cx(box, props.className),
      "data-state": props.state,
      "data-context": context,
      "data-page-context": pageContext,
      "data-orientation": props.orientation,
      "data-clickable-box": props.allowClickOnBox && props.state === "input",
      ...avoidBreakInside({
        extend: {
          top: 18,
          bottom: 26
        }
      }),
      onClick: props.allowClickOnBox && props.state === "input" ? props.onChange : undefined,
      children: [toggler, /*#__PURE__*/jsx("div", {
        className: content,
        children: props.children
      }), icon$1 && /*#__PURE__*/jsx("span", {
        className: icon,
        "data-state": props.state,
        children: icon$1
      })]
    })
  );
}

export { MediaBox };
//# sourceMappingURL=_media-box.js.map
